export const scrollToSection = (sectionId: string) => {
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (section) {
        const top = section.getBoundingClientRect().top;
        const headerHeight = document.querySelector('.header')?.getBoundingClientRect().height || 0;

        setTimeout(() => 
            window.scrollBy({ top: top - headerHeight, behavior: 'smooth' }), 
        100);
    }
};